import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { TeamPermissions } from './permissions'

const TEAM_READ_PERMS = [
  TeamPermissions.read,
  TeamPermissions.manageRoles,
  TeamPermissions.manageUsers,
  TeamPermissions.manageCapabilities,
] as const

async function lazyGuardedRoute(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
): Promise<{ Component: ComponentType }> {
  const mod = await importPage()
  const Page = mod[exportName]
  if (!Page) {
    throw new Error(`Team route page export "${exportName}" not found`)
  }
  return { Component: createPermissionGuardedPage(TEAM_READ_PERMS, Page) }
}

/** Team admin routes under /admin/team. */
export const teamRoutes: RouteObject[] = [
  {
    path: 'admin/team',
    lazy: () => lazyGuardedRoute(() => import('./pages/team-directory-page'), 'TeamDirectoryPage'),
  },
  {
    path: 'admin/team/roles',
    lazy: () =>
      lazyGuardedRoute(() => import('./pages/team-roles-permissions-page'), 'TeamRolesPermissionsPage'),
  },
  {
    path: 'admin/team/:userId',
    lazy: () =>
      lazyGuardedRoute(() => import('./pages/team-member-detail-page'), 'TeamMemberDetailPage'),
  },
]
